import {
  ALLOWED_MEDIA_MIME_TYPES,
  isAllowedMediaMimeType,
  MAX_MEDIA_FILE_SIZE_BYTES,
} from "../../channel/mmsConstraints";

import {
  type AssetPickerConstraints,
  formatMimeTypes,
} from "@/features/AssetLibrary/components/assetPickerConstraints";

const mmsAcceptedMime: Record<string, string[]> = {};
for (const mime of ALLOWED_MEDIA_MIME_TYPES) {
  // Subtype-derived extension works for image/* but not text/vcard (.vcf).
  mmsAcceptedMime[mime] =
    mime === "text/vcard" ? [".vcf"] : [`.${mime.split("/")[1]}`];
}

const mmsTypes = formatMimeTypes(ALLOWED_MEDIA_MIME_TYPES);

export const MMS_PICKER_CONSTRAINTS: AssetPickerConstraints = {
  title: "Select media",
  // vCards upload as "document".
  assetTypes: ["image", "document"],
  isSelectable: isAllowedMediaMimeType,
  unsupportedTypeMessage: `This file type is not supported for text messages. Please select a ${mmsTypes} file.`,
  maxSizeBytes: MAX_MEDIA_FILE_SIZE_BYTES,
  uploadAccept: mmsAcceptedMime,
  uploadHint: `Supported: ${mmsTypes}`,
  emptyLabel: "No images in your library yet",
  // Browsers report .vcf inconsistently (empty type or text/x-vcard).
  normalizeFile: (file) =>
    file.type !== "text/vcard" && file.name.toLowerCase().endsWith(".vcf")
      ? new File([file], file.name, { type: "text/vcard" })
      : file,
};
